import React from "react";
import { CheckCircle, XCircle, MinusCircle } from "lucide-react";
import i18n from "../../i18n";

// questType → cevap seçenekleri (doldurma sayfası + önizleme + düzenleyici aynı tanımı kullanır)
// API: inspection_type.main_question_quest_type / inspection_question.quest_type integer kodu
// Değerler: 1=Uygun/UygunDeğil, 2=Evet/Hayır, 3=Var/Yok, 4=ProblemYok/ProblemVar
export const ANSWER_OPTIONS = {
  1: [
    { value: 1, get label() { return i18n.t("saha:sahaFormFill.uygun"); },        color: "success",   icon: <CheckCircle  size={15} /> },
    { value: 2, get label() { return i18n.t("saha:sahaFormFill.uygunDegil"); },  color: "danger",    icon: <XCircle      size={15} /> },
    { value: 3, get label() { return i18n.t("saha:sahaFormFill.gerekYok"); },    color: "secondary", icon: <MinusCircle  size={15} /> },
  ],
  2: [
    { value: 1, get label() { return i18n.t("common:evet"); },         color: "success",   icon: <CheckCircle  size={15} /> },
    { value: 2, get label() { return i18n.t("common:hayir"); },        color: "danger",    icon: <XCircle      size={15} /> },
    { value: 3, get label() { return i18n.t("saha:sahaFormFill.gerekYok"); },    color: "secondary", icon: <MinusCircle  size={15} /> },
  ],
  3: [
    { value: 1, get label() { return i18n.t("saha:sahaFormFill.var"); },          color: "success",   icon: <CheckCircle  size={15} /> },
    { value: 2, get label() { return i18n.t("saha:sahaFormFill.yok"); },          color: "danger",    icon: <XCircle      size={15} /> },
    { value: 3, get label() { return i18n.t("saha:sahaFormFill.gerekYok"); },    color: "secondary", icon: <MinusCircle  size={15} /> },
  ],
  4: [
    { value: 1, get label() { return i18n.t("saha:sahaFormFill.problemYok"); },  color: "success",   icon: <CheckCircle  size={15} /> },
    { value: 2, get label() { return i18n.t("saha:sahaFormFill.problemVar"); },  color: "danger",    icon: <XCircle      size={15} /> },
    { value: 3, get label() { return i18n.t("saha:sahaFormFill.gerekYok"); },    color: "secondary", icon: <MinusCircle  size={15} /> },
  ],
};
